import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { LangService } from 'src/app/core/services/lang.service';
import { GridService } from 'src/app/shared/services/grid.service';
import { DataLoadService } from 'src/app/shared/services/data-load.service';
import { DateService } from 'src/app/shared';

@Component({
  selector: 'app-hr-vehicle-list',
  templateUrl: './../../../templates/forms/modals/vehicle-type-list.component.html',
})
export class VehicleTypeListComponent implements OnInit {
  @Input()
  config: any;
  
  @Input()
  modalShow: boolean = true;

  @Input()
  optionalParam: any;
  
  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  dataObj:any;

  columnDefs = [];
  colObj;
  grid: any;
  gridId: string = "HrVeicle"; 

  vehicletList: any[] = [];

  constructor(
      public langService: LangService
    , private dataService: DataLoadService
    , public gridService: GridService
    , public dateService: DateService) {
    this.colObj = [
      { headerName: langService.langData.vehicleType, field: 'VEHICLE_TYPE_NAME', sortable: true, resizable: true, hide: false }, 
    ];
   }

  ngOnInit() {
    this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
    }
    onGridReady(grid) {
      this.grid = grid;
      this.gridService.sizeColumnsToFit(grid, this.gridId);
      this.dataService.load('FG_HR_COMM_VEHICLE_TYPE').subscribe(result=>{
        this.vehicletList = result.body;
      })
    }
    itemClick(_item) {
      this.modalShow = false; 
      this.dataObj=_item;
      this.submit.next(_item);
    }

}
